/* eslint-disable no-unused-vars */
import { Api } from '@/lib/api'

export type Endpoint = {
  id: string
  display: string
  description?: string
  icon?: string
  svgPath?: string
  swagger?: string
  schema?: Api
  route?: any
  hidden?: boolean
  children?: Endpoint[]
}

export const GRAPHQL_URL = process.env.VUE_APP_GRAPHQL_URL

class Apis {
  endpoints: Endpoint[] = [
    {
      id: 'rest',
      icon: 'bed',
      display: 'REST APIs',
      description: 'Our Rest APIs allow you to push and pull information between your KSAT console and other vendors you use.',
      children: [
        {
          id: 'reporting',
          icon: 'file-invoice',
          display: 'Reporting',
          description: 'Our reporting APIs allow you to pull phishing, training, user, and group data from your KSAT console.',
          swagger: '/elvis-swagger.yml',
          route: { name: 'restAPI', params: { api: 'reporting' } }
        },
        {
          id: 'userEvents',
          icon: 'users',
          display: 'User Events',
          description: "Our user event APIs allow you to push your users' security-related events or training activities from external sources and push them into or pull them from your KSAT console.",
          swagger: '/echelon-swagger.yml',
          route: { name: 'restAPI', params: { api: 'userEvents' } }
        }
      ]
    },
    {
      id: 'graphql',
      svgPath: 'M 6.4654 32.0493 L 4.8476 31.1155 L 22.8645 -0.0897 L 24.4823 0.844 Z M 4.4775 28.6225 H 40.5113 V 30.49 H 4.4775 Z M 23.2144 40.0784 L 5.1908 29.6721 L 6.1245 28.0544 L 24.1481 38.4606 Z M 38.871 12.9569 L 20.8474 2.5506 L 21.7811 0.9329 L 39.8047 11.3391 Z M 6.129 12.949 L 5.1953 11.3324 L 23.2189 0.9261 L 24.1526 2.5428 Z M 38.5391 32.0493 L 20.5222 0.844 L 22.1389 -0.0897 L 40.1557 31.1155 Z M 5.9063 10.0938 H 7.7737 V 30.9063 H 5.9063 Z M 37.2263 10.0938 H 39.0938 V 30.9063 H 37.2263 Z M 22.896 39.2875 L 22.0804 37.8745 L 37.7561 28.8239 L 38.5718 30.2369 Z M 41.5688 31.5138 C 40.4887 33.3925 38.0813 34.0337 36.2025 32.9537 C 34.3238 31.8737 33.6825 29.4663 34.7625 27.5875 C 35.8425 25.7088 38.25 25.0675 40.1287 26.1475 C 42.0188 27.2387 42.66 29.635 41.5688 31.5138 M 10.2262 13.4125 C 9.1462 15.2912 6.7387 15.9325 4.86 14.8525 C 2.9812 13.7725 2.34 11.365 3.42 9.4863 C 4.5 7.6075 6.9075 6.9663 8.7862 8.0463 C 10.665 9.1375 11.3062 11.5337 10.2262 13.4125 M 3.4312 31.5138 C 2.3512 29.635 2.9925 27.2387 4.8712 26.1475 C 6.75 25.0675 9.1462 25.7087 10.2375 27.5875 C 11.3175 29.4663 10.6762 31.8625 8.7975 32.9537 C 6.9075 34.0338 4.5112 33.3925 3.4312 31.5138 M 34.7738 13.4125 C 33.6938 11.5337 34.335 9.1375 36.2138 8.0463 C 38.0925 6.9663 40.4888 7.6075 41.58 9.4862 C 42.66 11.365 42.0188 13.7613 40.14 14.8525 C 38.2613 15.9325 35.8537 15.2912 34.7738 13.4125 M 22.5 42.5275 C 20.3287 42.5275 18.5738 40.7725 18.5738 38.6013 C 18.5738 36.43 20.3287 34.675 22.5 34.675 C 24.6713 34.675 26.4262 36.43 26.4262 38.6013 C 26.4262 40.7613 24.6713 42.5275 22.5 42.5275 M 22.5 6.325 C 20.3287 6.325 18.5738 4.57 18.5738 2.3987 C 18.5738 0.2275 20.3287 -1.5275 22.5 -1.5275 C 24.6713 -1.5275 26.4262 0.2275 26.4262 2.3987 C 26.4262 4.57 24.6713 6.325 22.5 6.325',
      display: 'GRAPH APIs',
      description: 'Our Graph APIs allow you to utilize complex queries and mutations to perform most functions of the supported KnowBe4 products via API.',
      children: [
        {
          id: 'ksat',
          svgPath: 'M 16.00,0.68 C 22.22,-0.18 28.37,0.88 33.18,5.19 43.73,14.67 41.09,32.06 28.08,37.93 24.58,39.51 22.50,39.51 18.79,39.47 4.93,39.31 -3.35,24.36 1.82,12.07 4.39,5.96 9.64,2.10 16.00,0.68 Z M 28.02,28.85 C 28.02,28.85 29.03,29.99 30.40,31.11 33.34,27.88 35.76,23.58 35.42,19.04 34.84,11.38 29.01,4.84 21.11,4.65 16.23,4.53 11.96,5.94 8.72,9.76 5.70,13.34 5.61,17.30 5.61,17.30 5.61,17.30 3.72,17.22 2.77,17.30 2.77,17.30 6.66,23.86 6.66,23.86 11.82,17.47 10.44,20.06 11.82,17.65 11.82,17.65 9.04,17.65 9.04,17.65 11.06,5.27 28.73,4.92 31.55,17.18 32.04,19.32 31.75,22.14 30.88,24.15 30.04,26.06 28.02,28.85 28.02,28.85 Z',
          display: 'KSAT',
          schema: new Api(`${GRAPHQL_URL}?scope=public_kmsat`),
          route: { name: 'graphqlApi', params: { api: 'ksat' } }
        },
        {
          id: 'phisher',
          svgPath: 'M 1.92,0.85 C 3.96,-0.42 3.43,0.42 19.79,0.10 30.73,0.52 36.25,-0.73 37.76,1.06 40.06,2.59 39.99,5.91 40.00,8.33 40.00,8.33 40.00,31.67 40.00,31.67 39.99,33.78 40.27,37.07 38.67,38.67 37.07,40.27 33.78,39.99 31.67,40.00 31.67,40.00 8.33,40.00 8.33,40.00 5.91,39.99 2.38,40.38 0.85,38.08 -0.10,36.65 0.01,34.17 0.00,32.50 0.00,32.50 0.00,8.33 0.00,8.33 0.01,4.92 -0.49,3.44 1.92,0.85 Z M 17.50,6.67 C 17.50,6.67 6.67,6.67 6.67,6.67 6.67,6.67 6.67,33.33 6.67,33.33 6.67,33.33 17.50,33.33 17.50,33.33 17.50,33.33 17.50,27.50 17.50,27.50 17.50,27.50 12.50,27.50 12.50,27.50 12.50,27.50 12.50,23.33 12.50,23.33 12.50,23.33 17.50,23.33 17.50,23.33 17.50,23.33 17.50,16.67 17.50,16.67 17.50,16.67 12.50,16.67 12.50,16.67 12.50,16.67 12.50,12.50 12.50,12.50 12.50,12.50 17.50,12.50 17.50,12.50 17.50,12.50 17.50,6.67 17.50,6.67 Z M 28.23,22.40 C 34.07,20.00 34.99,11.74 29.89,8.12 27.68,6.53 25.07,6.69 22.50,6.67 22.50,6.67 22.50,12.50 22.50,12.50 22.50,12.50 27.50,12.50 27.50,12.50 27.50,12.50 27.50,16.67 27.50,16.67 27.50,16.67 22.68,16.67 22.68,16.67 22.51,18.41 22.43,20.84 22.68,22.50 24.58,25.73 28.02,31.25 29.07,33.12 30.52,33.68 34.60,33.32 36.15,33.33 36.15,33.33 28.23,22.40 28.23,22.40 Z',
          display: 'PhishER',
          schema: new Api(`${GRAPHQL_URL}?scope=phisher`),
          route: { name: 'graphqlApi', params: { api: 'phisher' } }
        },
        {
          id: 'ksat-partners',
          icon: 'handshake',
          display: 'KSAT Partners',
          hidden: true,
          schema: new Api(`${GRAPHQL_URL}?scope=partner_public_kmsat`),
          route: { name: 'graphqlApi', params: { api: 'ksat-partners' } }
        }
      ]
    }
  ]

  client (id: string): Api {
    return this.getEndpoint(id)?.schema
  }

  swagger (id: string) {
    return this.getEndpoint(id)?.swagger
  }

  getEndpoint (id: string, endpoints = this.endpoints): Endpoint | undefined {
    for (let endpoint of endpoints) {
      endpoint = endpoint.children ? this.getEndpoint(id, endpoint.children) : endpoint
      if (endpoint?.id === id) return endpoint
    }
  }
}

const apis = new Apis()
export default apis
